/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-1",
    "aws_dynamodb_all_tables_region": "us-west-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "subscribers-prod",
            "region": "us-west-1"
        },
        {
            "tableName": "alertshistory-prod",
            "region": "us-west-1"
        },
        {
            "tableName": "templatecontent-prod",
            "region": "us-west-1"
        },
        {
            "tableName": "incident-prod",
            "region": "us-west-1"
        }
    ],
    "aws_cognito_identity_pool_id": "us-west-1:fe0d9bbe-9164-4677-b994-dec1722be935",
    "aws_cognito_region": "us-west-1",
    "aws_user_pools_id": "us-west-1_4JmOXNA2R",
    "aws_user_pools_web_client_id": "ivjualiil1ii33886agpjmc9f",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_cloud_logic_custom": [
        {
            "name": "scgapi",
            "endpoint": "https://njsjvyi3k5.execute-api.us-west-1.amazonaws.com/prod",
            "region": "us-west-1"
        }
    ]
};


export default awsmobile;
